// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"386":"a960b74e29db1d87","761":"e274e6d88462feff"}[chunkId] + ".js";
};